import { authFetch } from "../utils/authFetch";
import { ANNOTATION_SESSION_ENDPOINT } from "../utils/constants";

export class AnnotationSheetAccessError extends Error {
  constructor(kind, status, payload = {}) {
    super(payload.reason || payload.code || kind);
    this.name = "AnnotationSheetAccessError";
    this.kind = kind;
    this.status = status;
    this.payload = payload;
  }
}

export async function requestAnnotationSheetAccess({
  sheetId,
  sessionId,
  action,
  keepalive = false,
}) {
  let response;
  try {
    response = await authFetch(`${ANNOTATION_SESSION_ENDPOINT}/annotationSheetAccess`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        sheet_id: sheetId,
        session_id: sessionId,
        action,
      }),
      ...(keepalive ? { keepalive: true } : {}),
    });
  } catch (error) {
    throw new AnnotationSheetAccessError("network", 0, {
      code: error?.message || "NETWORK_ERROR",
    });
  }

  let payload = {};
  try {
    payload = await response.json();
  } catch {
    payload = {};
  }

  if (!response.ok) {
    const kind = response.status === 423 ? "conflict" : "network";
    throw new AnnotationSheetAccessError(kind, response.status, payload);
  }

  return payload;
}
